<script lang="ts">
	import { storeChatModal } from '$lib/js/stores'

	function checkTimeRange() {
		const now: Date = new Date()
		const day: number = now.getDay() // 0 is Sunday, 1-5 is Monday-Friday, 6 is Saturday
		const hours: number = now.getHours()

		// Check if current time is Monday-Friday (1-5) AND between 9:00-18:00 (9-18 hours)
		return day >= 1 && day <= 5 && hours >= 9 && hours < 18
	}
</script>

<button class="chat-icon" onclick={() => ($storeChatModal = !$storeChatModal)}>
	{#if !$storeChatModal}
		<span class="icon icon-chat"></span>
	{:else}
		<span class="icon icon-cross"></span>
	{/if}

	{#if checkTimeRange()}
		<span class="active"></span>
	{/if}
</button>

<style lang="scss">
	.chat-icon {
		z-index: 9;
		display: flex;
		align-items: center;
		justify-content: center;
		position: fixed;
		right: 20px;
		bottom: 20px;
		width: 64px;
		height: 64px;
		color: white;
		background: var(--color-main);
		border-radius: 50px;
		box-shadow: 0px 0px 17px 5px rgba(0, 0, 0, 0.12);

		@media (min-width: 769px) {
			right: 20px;
		}

		@media (min-width: 1500px) {
			bottom: 20px;
		}

		span.icon-chat, {
			font-size: 30px;
		}

		span.icon-cross {
			font-size: 18px;
		}

		span.active {
			width: 16px;
			height: 16px;
			display: block;
			border-radius: 16px;
			position: absolute;
			bottom: 0;
			right: -6px;
			background: var(--secondary);
			border: 2px solid #ffffff;
		}
	}
</style>
